import {
  doRequest
} from './common';

export const fetchConfig = async () => {
  let result;

  try {
    result = await doRequest({
      url: '/api/config',
      doNormalize: false
    });
  } catch (error) {
    console.log(error);
  }

  return result;
};



// WEBPACK FOOTER //
// ./src/services/api/config.js